<template>
    <div
        :class="[
            'relative flex items-center justify-center bg-white rounded-full font-semibold p-[2px] gap-[2px]',
            'camera-angle-toolbar',
        ]"
        :style="{ '--toolbar-index': toolbarViewIndex }"
    >
        <div
            :class="[
                'absolute top-[2px] left-[2px] h-[calc(100%-4px)] w-[var(--toolbar-button-width)]',
                'rounded-full bg-black transition-transform duration-300 ease-out',
            ]"
            :style="{ transform: toolbarHighlightTransform }"
            aria-hidden="true"
        />
        <button
            v-for="view in views"
            :key="view.value"
            type="button"
            :class="[
                'relative z-10 w-[83px] md:w-[76px] xl:w-[88px] py-1 rounded-full',
                'transition-colors duration-300 ease-out',
                'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                activeView === view.value ? 'text-white' : 'hover:bg-gray-F0F0F0',
            ]"
            @click="$emit('select-view', view.value)"
        >
            {{ $t(view.translationKey) }}
        </button>
    </div>
</template>

<script>
    export default {
        emits: ['select-view'],

        props: {
            activeView: {
                type: String,
                required: true,
            },
        },

        computed: {
            views() {
                return [
                    { value: 'Face', translationKey: 'FACE' },
                    { value: 'Sole', translationKey: 'SOLE' },
                    { value: 'Back', translationKey: 'BACK' },
                    { value: 'Top', translationKey: 'TOP' },
                ];
            },

            toolbarViewIndex() {
                const index = this.views.findIndex((view) => view.value === this.activeView);

                return Math.max(index, 0);
            },

            toolbarHighlightTransform() {
                return `translateX(calc(${this.toolbarViewIndex} * (var(--toolbar-button-width) + 2px)))`;
            },
        },
    };
</script>

<style scoped>
    .camera-angle-toolbar {
        --toolbar-button-width: 83px;
    }

    @media (min-width: 768px) {
        .camera-angle-toolbar {
            --toolbar-button-width: 76px;
        }
    }

    @media (min-width: 1280px) {
        .camera-angle-toolbar {
            --toolbar-button-width: 88px;
        }
    }
</style>
